import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDoctorRanks } from "../../actions/userActions/doctorRankAction";
import { Link, useHistory } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import SearchInput from "../subComponents/search/SearchInput";
import DynamicTable from "../reuse_components/DynamicTable";
import CustomButton from "../subComponents/buttons/CustomButton";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import AddDoctorRanks from "./AddDoctorRanks";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";
import { Download } from 'lucide-react';
import { IconButton } from "@mui/material";
import { downloadDoctorRank } from "../../actions/userActions/doctorRankAction";
function DoctorRanks() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1)
  const [previousQuery, setPreviousQuery] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [doctorRankdata, setdoctorRankdata] = useState([]);
  useEffect(() => {
    dispatch(getDoctorRanks());
  }, []);
  const ranks = useSelector((state) => state.doctor_rank_reducer.ranks);
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = ranks?.totalPages || 0;
  const totalItems = ranks?.totalCount || 0;
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const isLoading = useSelector((state) => state.doctor_rank_reducer.isDoctorRankLoading);
  useEffect(() => {
    const pageNumber = currentPage;
  
      if (searchQuery !== previousQuery) {
        setCurrentPage(1);
      }
      dispatch(getDoctorRanks(pageNumber, itemsPerPage, searchQuery));
      setPreviousQuery(searchQuery);
  
    }, [currentPage, searchQuery]);
 
  useEffect(() => {
    const RanksData = ranks && ranks.result?.map((ranks) => ({
      ...ranks,
      status: (
        <span className={ranks.active ? "status-badge-active" : "status-badge-inactive"}>
          {ranks.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    setdoctorRankdata(RanksData);
  }, [ranks]);
  const handleAddDoctorDesignationClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditDoctorDesignation = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleItemsPerPageChange = (value) => {
    const pageNumber = firstPage;
    dispatch(getDoctorRanks(pageNumber, value, searchQuery));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const handleSaveData = async (newData) => {
    dispatch(getDoctorRanks(currentPage, itemsPerPage, searchQuery));
    setShowModal(false);
  };
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
     { label: `${t("status")}`, accessor: "status" },  
  ];
  const actions = [  
    {
        label: 'Edit Doctor Designation',
        icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
        permission: 'CanUpdateDoctorRank',
        handler:handleEditDoctorDesignation,
    },
];
const handleDoctorRankDownload = () => {
  dispatch(downloadDoctorRank());
};
const handleSearchChange = (e) => {
  setSearchQuery(e.target.value);
  setCurrentPage(1);
};
  return (
    <>
      <div>
        <LoadingOverlay isVisible={isLoading} />
      <div className="main-container">
           <div className="content-wrapper">
                <div className="pagination">
                <SearchInput
                        placeholder="Search"
                        onChange={handleSearchChange}
              value={searchQuery}
             />
                  <div className="flex-align-center">
                  <div className="items-per-page-container">
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                      <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
                      <div style={{ paddingRight: '12px' }}>
                          <IconButton onClick={handleDoctorRankDownload}>
                            <Download />
                          </IconButton>
                      </div>
                        {permissions && permissions.includes("CanAddDoctorRank") && (
                            <CustomButton text={t("addNew")} onClick={handleAddDoctorDesignationClick} />
                        )}
                    </div>
                </div>
              
            </div>
            <DynamicTable
                    data={ doctorRankdata}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                    showPagination={totalItems > 0}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
        </div>
        
        {showModal && (
        <AddDoctorRanks
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
      </div>
     
    </>
  );
}

export default DoctorRanks;
